import { Component, Input, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ContactObject } from 'src/app/models/orders/order-details-sites/sites-table/sites-contacts-table/contact-object.model';
import { SitesObject } from 'src/app/models/orders/order-details-sites/sites-tab-object-model';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-contacts-table',
  templateUrl: './contacts-table.component.html',
  styleUrls: ['./contacts-table.component.css']
})
export class ContactsTableComponent implements OnChanges {

  @Input() sites: Array<SitesObject>;
  @Input() dataSourceId: number;

  columnsToDisplay: string[] = ['name', 'phone', 'email'];
  dataSource: MatTableDataSource<ContactObject>;
  contactsNumber: number;
  constructor() { }

  ngOnChanges(): void {
    if (!isNullOrUndefined(this.sites)) {
      this.contactsNumber = this.sites[this.dataSourceId].getContacts().length;
      this.dataSource = new MatTableDataSource<ContactObject>(this.sites[this.dataSourceId].getContacts());
    } else {
      this.dataSource = new MatTableDataSource<ContactObject>();
    }
  }
}
